import { EMPTY_STR, FORWARD_SLASH } from './constants/common';

export const parseURLEnd = (href: string = EMPTY_STR) => {
    if (href !== EMPTY_STR) {
        if (href.endsWith('/')) {
            href = href.slice(0, -1);
        }

        const splitHref = href.split(FORWARD_SLASH);
        if (splitHref && splitHref.length) {
            const len = splitHref.length;
            let splitEnd;
            if (splitHref[len - 1].includes('index') && len > 1) {
                splitEnd = splitHref[len - 2];
            } else {
                splitEnd = splitHref[splitHref.length - 1];
            }

            splitEnd = splitEnd.replace(/[{()}]/g, EMPTY_STR);
            if (splitEnd.includes('.')) {
                const result = new RegExp(/^(?:[^\.]*)(?:\.)([^\.]*)/g).exec(splitEnd);
                if (result && result.length) {
                    splitEnd = result[result.length - 1];
                }
            }

            return splitEnd;
        }
    }
    return href;
};
